import { React, useEffect, useContext, useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { ConsoleView } from "react-device-detect";


//로그인된 사람만 접근 가능
export const PrivateRoute = ({ children }) => {
    const LoginBoolean =  (localStorage.length > 10 && Date.now() <= JSON.parse(localStorage.getItem("expire_dt")))? true:false;
    const navigate = useNavigate();
    const location = useLocation();
    const D = new Date();
    const sessionD = new Date();
    sessionD.setHours(sessionD.getHours() + 2);
    const D_year = String(D.getFullYear());
    const D_month = String(D.getMonth()+1).padStart(2,"0");
    const D_day = String(D.getDate()).padStart(2,"0");
    const D_h = String(D.getHours()).padStart(2,"0");
    const D_m = String(D.getMinutes()).padStart(2,"0");
    const D_s = String(D.getSeconds()).padStart(2,"0");
    const sessionD_year = String(sessionD.getFullYear());
    const sessionD_month = String(sessionD.getMonth()+1).padStart(2,"0");
    const sessionD_day = String(sessionD.getDate()).padStart(2,"0");
    const sessionD_h = String(sessionD.getHours()).padStart(2,"0");
    const sessionD_m = String(sessionD.getMinutes()).padStart(2,"0");
    const sessionD_s = String(sessionD.getSeconds()).padStart(2,"0");
    const now = D_year+'-'+D_month+'-'+D_day+' '+D_h+':'+D_m+':'+D_s;
    const newSessionTime = sessionD_year+'-'+sessionD_month+'-'+sessionD_day+' '+sessionD_h+':'+sessionD_m+':'+sessionD_s;
    var return_status = ''
    
    const TokenUpdate = async(newSessionTime) => {
        await axios.post("/api/Auth/TokenUpdate", new URLSearchParams({
            DiffToken: localStorage.getItem("DiffToken"),
            TokenTime: newSessionTime,
            user_id: localStorage.getItem("user_id"),
            user_login_token: localStorage.getItem("user_login_token"),
            device_type: localStorage.getItem("deviceType"),
            menu_url: String(window.location.pathname).split("/").slice(0, 3).join("/")
        }),
        { withCredentials: true })
        .then(function (response) {
            return_status = response.data.status;
            
            if(response.data.status === 'Y'){
                localStorage.setItem("expire_dt", new Date().getTime() + (60 * 60 * 24 * 14 * 1000));
                localStorage.setItem("nav", response.data.nav);
            }else if(response.data.status === 'J' && (localStorage.getItem("user_cross_login_yn")).toString() === 'N'){
                // user_cross_login_yn : Y이면 중복로그인 가능 대상자
                localStorage.setItem("LogoutType", 'J');
                return navigate('/Logout')
            }else if(response.data.status === 'M'){
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer:5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }else{
                localStorage.setItem("LogoutType", 'S');
                return navigate('/Logout')
            }
        })
        .catch(function (error) {
            localStorage.setItem("LogoutType", 'S');
            return navigate('/Logout')
        }).then(function () {
            window.dispatchEvent(new Event('localStorageChange'));
        });
    }

    if(location.pathname !== '/Logout' && location.pathname !== '/Login'){
        
        if(localStorage.getItem("resource_id") == '0'){
            // 사용자 로그인 일때, Token+메뉴권한까지 관리함.
            if(localStorage.getItem("LogoutType") == 'C'){
                navigate('/Logout')
            }else if((localStorage.getItem("DiffToken") != null && localStorage.getItem("DiffToken") != '' && localStorage.getItem("TokenTime") <= now)){
                Swal.fire({
                    title: '<p style="color:red">접속 오류</p>',
                    text: '장시간 사용하지 않아 다시 로그인 하셔야됩니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer:5000,
                    timerProgressBar: true
                }).then((value) => {
                    localStorage.setItem("LogoutType", 'F');
                    navigate('/Logout')
                });
            }else if((localStorage.getItem("DiffToken") == null || localStorage.getItem("DiffToken") == '') && LoginBoolean){
                Swal.fire({
                    title: '<p style="color:red">접속 오류</p>',
                    text: '보안 접속오류가 발생하여 다시 로그인 하셔야됩니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer:5000,
                    timerProgressBar: true
                }).then((value) => {
                    localStorage.setItem("LogoutType", 'S');
                    navigate('/Logout')
                });
            }else if(LoginBoolean){
                localStorage.setItem("TokenTime", newSessionTime);
            }
        }else{
            // 설비 로그인 일때, 메뉴권한 확인만 함.
        }
        
        if(LoginBoolean){
            TokenUpdate(newSessionTime);
        }
    }
    return LoginBoolean ? children : ( //로그인하지 않았을 경우 최초 페이지로 이동
        <>
        <Navigate to="/Login"/>
        </>);

};
//로그인하지 않은 사람만 접근 가능
export const PublicRoute = ({ children }) => {
    const navigate = useNavigate();
    let LoginBoolean =  false;
    if(localStorage.length > 10 && Date.now() <= JSON.parse(localStorage.getItem("expire_dt"))){
        LoginBoolean = true;
    }else{
        localStorage.clear();
    }
    if (LoginBoolean) {
        if(String(window.location.pathname).includes('/Login/') && (String(window.location.pathname).split("/")).length >= 3 && String((String(window.location.pathname).split("/"))[2]).length === 20){
            return children;
        }else if(typeof localStorage.getItem("main") == 'undefined' || localStorage.getItem("main") == null || localStorage.getItem("main") == '' || typeof localStorage.getItem("main") == 'undefined'){
            
            localStorage.setItem("LogoutType", 'S');
            navigate('/Logout');

        }else{
            window.location.href = localStorage.getItem("main");
        }
    } else {
        return children;
    }
    
};